import { API_URLS } from "./config.js";

const BASE_URL = `${API_URLS.base}/api/trade`;
const NINJA_URL = `${API_URLS.base}/api/ninja`;
const LEAGUES_URL = `${API_URLS.base}/api/leagues`;

export async function fetchLeagues() {
  const res = await fetch(LEAGUES_URL);
  if (!res.ok) throw new Error("Failed to fetch leagues");
  return res.json();
}

export async function fetchExchangeRate(league) {
  const res = await fetch(`${NINJA_URL}/currency?league=${league}`);
  if (!res.ok) throw new Error("Failed to fetch exchange rate");
  const data = await res.json();
  return (
    data.lines.find((i) => i.currencyTypeName === "Divine Orb")
      ?.chaosEquivalent || 0
  );
}

export function buildQuery({ size, ilvl, enchantId, option, notableIds }) {
  return {
    query: {
      status: { option: "available" },
      filters: {
        type_filters: {
          filters: {
            rarity: { option: "nonunique" },
          },
        },
        misc_filters: {
          filters: {
            ilvl: { min: ilvl, max: 100 },
            fractured_item: { option: "false" },
            corrupted: { option: "false" },
          },
        },
      },
      stats: [
        {
          type: "and",
          filters: [
            { id: enchantId, value: { option } },
            { id: "enchant.stat_3086156145", value: { min: size, max: size } },
          ],
        },
        {
          type: "count",
          min: notableIds.length,
          filters: notableIds.map((id) => ({ id })),
        },
      ],
    },
    sort: { price: "asc" },
  };
}

export async function getTradeData(query, league, sessionId) {
  if (!sessionId) throw new Error("POESESSID is required.");

  const headers = {
    "Content-Type": "application/json",
    "x-session-id": sessionId,
  };

  const searchRes = await fetch(`${BASE_URL}/search/${league}`, {
    method: "POST",
    headers,
    body: JSON.stringify(query),
  });

  if (!searchRes.ok) {
    const err = await searchRes.json().catch(() => ({}));
    if (searchRes.status === 403) {
      throw new Error("Invalid or expired POESESSID.");
    }
    if (searchRes.status === 429)
      throw new Error("Rate limited by PoE. Try increasing the delay.");
    throw new Error(
      err?.error?.message || `Trade API error (${searchRes.status})`,
    );
  }

  const searchData = await searchRes.json();

  if (searchData.error) {
    throw new Error(searchData.error.message || "Trade API returned an error.");
  }

  const searchId = searchData.id;
  if (!searchData.result?.length) return { total: 0, items: [], id: searchId };

  const fetchRes = await fetch(
    `${BASE_URL}/fetch/${searchData.result.slice(0, 10).join(",")}?query=${searchId}`,
    { headers },
  );

  if (!fetchRes.ok) {
    const err = await fetchRes.json().catch(() => ({}));
    throw new Error(
      err?.error?.message || `Fetch API error (${fetchRes.status})`,
    );
  }

  const fetchData = await fetchRes.json();

  return {
    total: searchData.total,
    items: fetchData.result || [],
    id: searchId,
  };
}